"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("./helpers");
const directoryRequiredFields = {
    interestIds: [],
    text: "",
    tags: [],
    title: "",
    images: [],
};
const parseActivityImages = (activity) => {
    let primaryImage = "";
    let largeImage = "";
    let smallImage = "";
    if (activity.images.length > 0) {
        if (activity.images[0]["10:10"].XXL) {
            largeImage = activity.images[0]["10:10"].XXL;
        }
        if (activity.images[0]["2:1"].L) {
            primaryImage = activity.images[0]["2:1"].L;
        }
        if (activity.images[0]["1:1"].M) {
            smallImage = activity.images[0]["1:1"].M;
        }
    }
    return Object.assign(activity, { primaryImage, smallImage, largeImage });
};
const extractImageFromNode = (node) => {
    let primaryImage = "";
    let largeImage = "";
    let smallImage = "";
    if (node.images.length > 0) {
        if (node.images[0]["10:10"].XXL) {
            largeImage = node.images[0]["10:10"].XXL;
        }
        if (node.images[0]["2:1"].L) {
            primaryImage = node.images[0]["2:1"].L;
        }
        if (node.images[0]["1:1"].M) {
            smallImage = node.images[0]["1:1"].M;
        }
    }
    else if (Object.prototype.hasOwnProperty.call(node, "icon")) {
        if (node.icon) {
            if (node.icon["1:1"].M) {
                smallImage = node.icon["1:1"].M;
            }
            if (node.icon["10:10"].XXL) {
                largeImage = node.icon["10:10"].XXL;
            }
            if (node.icon["2:1"].L) {
                primaryImage = node.icon["2:1"].L;
            }
        }
    }
    Object.assign(node, { primaryImage, smallImage, largeImage });
};
const parseImagesFromFolderStructure = (nodes) => {
    nodes.map((node) => {
        const nodeType = Object.keys(node)[0];
        extractImageFromNode(node[nodeType]);
        if (nodeType === "folder") {
            parseImagesFromFolderStructure(node[nodeType].children);
        }
        if (!Object.prototype.hasOwnProperty.call(node[nodeType], "type")) {
            Object.assign(node[nodeType], { type: nodeType });
        }
        return node;
    });
    return nodes;
};
const createActivitySlug = (activity) => {
    const slug = activity.title
        .split(" ")
        .join("-")
        .toLowerCase();
    return Object.assign(activity, { slug });
};
const parseVenuesFromResponse = ({ venues }) => venues.map(({ venue }) => venue);
const parseConventionsFromResponse = (response) => {
    if (response.conventions) {
        return response.conventions.map(({ convention }) => {
            let thumbnail = "";
            let primaryImage = "";
            if (convention.images.length > 0) {
                if (convention.images[0]["1:1"].M) {
                    thumbnail = convention.images[0]["1:1"].M;
                }
                if (convention.images[0]["2:1"].L) {
                    primaryImage = convention.images[0]["2:1"].L;
                }
            }
            return Object.assign(convention, { thumbnail, primaryImage });
        });
    }
    return [];
};
const parseActivityFromResponse = ({ activity }) => {
    if (!activity) {
        return {};
    }
    const updatedActivity = Object.assign(activity, { contentId: `-${activity.deeplink.split("--").pop()}` });
    return helpers_1.Helpers.compose(parseActivityImages, createActivitySlug)(updatedActivity);
};
const parseVenuesByLocationFromResponse = ({ venues, }) => ({
    near: venues.near.map(({ venue }) => venue),
    other: venues.other.map(({ venue }) => venue),
});
const parseActivitiesFromResponse = ({ activities }, locale) => activities.map(({ activity }) => {
    const updatedActivity = Object.assign(activity, { locale, contentId: `-${activity.deeplink.split("--").pop()}` });
    return helpers_1.Helpers.compose(parseActivityImages, createActivitySlug)(updatedActivity);
});
const parseReducedActivities = ({ activities }, locale) => activities.map(({ activity }) => Object.assign(activity, { locale, contentId: `-${activity.deeplink.split("--").pop()}`, smallImage: (activity.icon && activity.icon["1:1"].M) ? activity.icon["1:1"].M : "" }));
const parseWeatherFromResponse = ({ weather }) => weather;
const checkRequiredFields = (nodes, locale) => {
    nodes.map((node) => {
        const nodeType = Object.keys(node)[0];
        const currentNode = Object.assign(node[nodeType], { contentId: node[nodeType].id });
        if (nodeType !== "folder") {
            currentNode.locale = locale;
        }
        Object.keys(directoryRequiredFields).map((requiredField) => {
            if (!Object.prototype.hasOwnProperty.call(currentNode, requiredField)) {
                Object.assign(currentNode, {
                    [requiredField]: directoryRequiredFields[requiredField],
                });
            }
            return true;
        });
        if (nodeType === "folder") {
            checkRequiredFields(currentNode.children, locale);
        }
        return node;
    });
    return nodes;
};
const parseDirectoryFromResponse = ({ nodes }, locale) => {
    const formatedNodes = checkRequiredFields(nodes, locale);
    return parseImagesFromFolderStructure(formatedNodes);
};
const parseOffersFromResponse = ({ offers }, locale) => {
    const formatedOffers = checkRequiredFields(offers.all, locale);
    return parseImagesFromFolderStructure(formatedOffers);
};
const parseVenueFromResponse = ({ venue, status }) => {
    if (status === "error") {
        return false;
    }
    let hotelViewL = "";
    let hotelViewXXL = "";
    if (venue.icon) {
        if (Object.prototype.hasOwnProperty.call(venue.icon, "2:1")) {
            hotelViewXXL = venue.icon["2:1"].XXL;
            hotelViewL = venue.icon["2:1"].L;
        }
    }
    const customOptions = venue.customOptions || {};
    return Object.assign(venue, { hotelView: { L: hotelViewL, XXL: hotelViewXXL }, customOptions });
};
exports.default = {
    parseActivitiesFromResponse,
    parseVenuesFromResponse,
    parseConventionsFromResponse,
    parseVenuesByLocationFromResponse,
    parseVenueFromResponse,
    parseWeatherFromResponse,
    parseDirectoryFromResponse,
    parseOffersFromResponse,
    parseReducedActivities,
    parseActivityFromResponse,
};
